module.exports = __webpack_public_path__ + "static/20230619_045-334cd01ce2bcfaa55e5cb41203f97e39.jpg";